const ITEMS = [
  "NOT YOUR GRANDMOTHER'S TICK-TOCK",
  "TIME IS AN ILLUSION",
  "CURATED SURREALISM",
  "WEIRD O'CLOCK",
  "FUNCTIONAL ART",
  "DEFY THE BEIGE",
];

export default function EditorialMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-amber/30 bg-amber py-3.5"
    >
      <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="font-display text-sm font-black uppercase tracking-[0.2em] text-void">
              {item}
            </span>
            <span className="text-void/60">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
